import { Result } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const Loading = ({ message = "Undefined Error" }) => {
  return (
    <div
      className="loading-page"
      style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "60vh" }}
    >
      {message}
      <Result icon={<LoadingOutlined style={{ fontSize: "64px", color: "#99cccc" }} />} title={message} />
    </div>
  );
};

export default Loading;
